<template>
  <b-card title="Info Transaksi">
    <dl
      v-if="data.delivery"
      class="mb-2"
    >
      <dt>
        Info Pengiriman
        <hr>
      </dt>
      <dd>
        <dl
          class="row mb-0"
        >
          <dt class="col-sm-3">
            Kurir
          </dt>
          <dd class="col-sm-9 text-right">
            <span class="text-uppercase">{{ data.delivery.courier }}</span> - {{ data.delivery.service }}
          </dd>
        </dl>
        <dl
          v-if="data.delivery_insurance_fee && data.use_delivery_insurance"
          class="row mb-0"
        >
          <dt class="col-sm-4">
            <div class="d-flex align-items-center">
              <span>Asuransi</span>
              <img
                v-b-tooltip.hover.top="'Dilindungi asuransi pengiriman'"
                src="@/assets/images/icons/shield.png"
                alt="Shield"
                class="ml-25"
                width="16px"
                height="16px"
              >
            </div>
          </dt>
          <dd class="col-sm-8 text-right">
            {{ toCurrency(data.delivery_insurance_fee) }}
          </dd>
        </dl>
        <dl
          class="row mb-0"
        >
          <dt class="col-sm-4">
            No. Resi
          </dt>
          <dd class="col-sm-8 text-right">
            <span v-if="data.delivery.airway_bill">{{ data.delivery.airway_bill }}</span>
            <span v-else class="text-muted"><i>Menunggu pengiriman</i></span>
          </dd>
        </dl>
        <dl
          v-if="data.delivery && data.delivery.airway_bill"
          class="row mb-0"
        >
          <dt class="col-sm-3">
            Tipe
          </dt>
          <dd class="col-sm-9 text-right">
            <b-badge v-if="data.delivery.pickup_requested_at">
              Pick Up
            </b-badge>
            <b-badge v-else-if="data.delivery.dropoff_requested_at">
              Drop-off
            </b-badge>
            <b-badge v-else>
              Drop-off
            </b-badge>
          </dd>
        </dl>
        <dl
          v-if="data.delivery && data.delivery.pickup_requested_at && data.delivery.pickup_date"
          class="row mb-0"
        >
          <dt class="col-sm-6">
            Jadwal pickup
          </dt>
          <dd
            v-if="moment(data.delivery.pickup_date, 'DD-MM-YYYY').isSame(moment().add(-1, 'day'), 'day')"
            class="col-sm-6 text-right"
          >
            Kemarin, {{ data.delivery.pickup_time }}
          </dd>
          <dd
            v-else-if="moment(data.delivery.pickup_date, 'DD-MM-YYYY').isSame(moment().add(0, 'day'), 'day')"
            class="col-sm-6 text-right"
          >
            Hari ini, {{ data.delivery.pickup_time }}
          </dd>
          <dd
            v-else-if="moment(data.delivery.pickup_date, 'DD-MM-YYYY').isSame(moment().add(1, 'day'), 'day')"
            class="col-sm-6 text-right"
          >
            Besok, {{ data.delivery.pickup_time }}
          </dd>
          <dd
            v-else-if="moment(data.delivery.pickup_date, 'DD-MM-YYYY').isSame(moment().add(2, 'day'), 'day')"
            class="col-sm-6 text-right"
          >
            Lusa, {{ data.delivery.pickup_time }}
          </dd>
          <dd
            v-else
            class="col-sm-6 text-right"
          >
            {{ moment(data.delivery.pickup_date, 'DD-MM-YYYY').format('DD MMM') }}, {{ data.delivery.pickup_time }}
          </dd>
        </dl>
        <dl
          v-if="trackStatus"
          class="row mb-0"
        >
          <dt class="col-sm-4">
            Status
          </dt>
          <dd class="col-sm-8 text-right text-capitalize">
            {{ trackStatus }}
          </dd>
        </dl>
      </dd>
    </dl>

    <div v-if="data.delivery && !data.delivery.pickup_requested_at && data.delivery.pickup_date && data.delivery.pickup_time" class="alert alert-secondary">Transaksi ini sebelumnya direquest pickup untuk {{ moment(data.delivery.pickup_date, 'DD-MM-YYYY').format('DD MMM') }}, {{ data.delivery.pickup_time }}</div>

    <dl class="mb-2">
      <dt>
        Rincian
        <hr>
      </dt>
      <dd>
        <dl class="row mb-0">
          <dt class="col-sm-6">
            TOTAL HARGA <br><small>({{ data.items.length }} BARANG)</small>
          </dt>
          <dd class="col-sm-6 text-right font-weight-bolder">
            {{ toCurrency(data.total) }}
          </dd>
        </dl>
      </dd>
      <hr>
      <dd>
        <dl
          v-if="berat.gram"
          class="row mb-0"
        >
          <dt class="col-sm-6">
            Total Berat
          </dt>
          <dd class="col-sm-6 text-right">
            {{ toThousands(berat.gram) }} gr / {{ toThousands(berat.kg) }} Kg
          </dd>
        </dl>
        <dl
          v-if="data.delivery"
          class="row mb-0"
        >
          <dt class="col-sm-6">
            Ongkos Kirim
          </dt>
          <dd class="col-sm-6 text-right">
            {{ toCurrency(data.delivery.fee) }}
          </dd>
        </dl>
        <dl
          v-if="discountTotal"
          class="row mb-0"
        >
          <dt class="col-sm">
            Total Diskon Produk
          </dt>
          <dd class="col-sm-auto text-right">
            - {{ toCurrency(discountTotal) }}
          </dd>
        </dl>
      </dd>
      <hr v-if="berat.gram || discountTotal">
      <dd>
        <dl class="row mb-0">
          <dt class="col-sm-6">
            TOTAL BELANJA
          </dt>
          <dd class="col-sm-6 text-right font-weight-bolder">
            {{ toCurrency(totalBelanja) }}
          </dd>
        </dl>
      </dd>
    </dl>
  </b-card>
</template>

<script>
import {
  BCard,
  BBadge, VBTooltip,
} from 'bootstrap-vue'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  components: {
    BCard,
    BBadge,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState('transaction', ['trackHistory', 'trackStatus']),
    berat() {
      if (this.data) {
        let weight = 0
        const listProduct = this.data.items
        listProduct.forEach(item => {
          weight += item.product.weight
        })

        const weightKg = weight / 1000

        return {
          kg: weightKg,
          gram: weight,
        }
      }

      return ''
    },
    discountTotal() {
      if (this.data) {
        let discount = 0
        const listProduct = this.data.items
        listProduct.forEach(item => {
          discount += item.discount
        })

        return discount
      }
      return ''
    },
    totalBelanja() {
      const harga = this.data.total
      const ongkir = this.data.delivery ? this.data.delivery.fee : 0
      const deliveryInsuranceFee = this.data.delivery_insurance_fee

      return harga + ongkir + deliveryInsuranceFee
    },
  },
  methods: { moment },
}
</script>

<style lang="scss" scoped>
dt {
    font-weight: bolder !important;
}
</style>
